import { render, staticRenderFns } from "./afterSaleMsg.vue?vue&type=template&id=3099120a&scoped=true&"
import script from "./afterSaleMsg.vue?vue&type=script&lang=js&"
export * from "./afterSaleMsg.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleMsg.vue?vue&type=style&index=0&id=3099120a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3099120a",
  null
  
)

export default component.exports